import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

const element: HTMLElement = document.getElementById('forms') as HTMLElement;

if (element != null) {
  const formsOverviewPageID : number =  parseInt(element.getAttribute("data-overviewPageID") ?? "0");
  const labels: any = JSON.parse(element.getAttribute("data-translations") as string);
  const region = element.getAttribute("data-region") as string;
  ReactDOM.render(
    <React.StrictMode>
      <App overviewID={formsOverviewPageID} labels={labels} region={region} />
    </React.StrictMode>,
    element
  );
}
